import React from 'react';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';

import styled from 'styled-components';

export interface Candidate {
    star_rating: string;
    current_job_title: string;
    seniority: string;
    years_of_experience: number;
    job_title_category: string[];
    selling_points: string[];
    primary_skills: string;
}

interface CandidateProfileProps {
  candidate: Candidate;
}

const StyledCard = styled(Card)`
  margin: 1rem;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  &:hover {
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.1);
  }
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #e0e0e0;
  background-color: #f0f2f5; // Cool grey background
`;

const CardTitle = styled(Card.Title)`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 500;
  color: #333;
`;

const CardBody = styled(Card.Body)`
  background-color: #fafbfc; // Cool very light gray background
`;

const InterestedButton = styled(Button)`
  background-color: #28a745;
  border-color: #28a745;
  min-width: 130px;
  margin-left: 1rem;
  &:hover {
    background-color: #218838;
    border-color: #1e7e34;
  }
`;

export const CandidateProfile: React.FC<CandidateProfileProps> = ({ candidate }) => {
    const { selling_points, seniority, job_title_category } = candidate;
  
    const formatSellingPoint = (sellingPoint: string) => {
      const parts = sellingPoint.split(/:(.+)/);
      return (
        <>
          <strong>{parts[0]}:</strong>
          {parts[1]}
        </>
      );
    };
  
    const handleButtonClick = () => {
      const subject = encodeURIComponent(selling_points[0]);
      const emailLink = `mailto:info@sourcecoders.io?subject=${subject}`;
      window.location.href = emailLink;
    };
  
    return (
      <StyledCard>
        <CardHeader>
          <CardTitle>{selling_points[0]}</CardTitle>
          <InterestedButton onClick={handleButtonClick}>I'm Interested</InterestedButton>
        </CardHeader>
        <CardBody>
          <ListGroup variant="flush">
              {selling_points.map((sellingPoint, index) => (
                  (index !== 0 && sellingPoint !== "") &&
                      <ListGroup.Item key={index}>{formatSellingPoint(sellingPoint)}</ListGroup.Item>
              ))}
          </ListGroup>
        </CardBody>
      </StyledCard>
    );
  };
  
  
